export const Title: React.FC<React.PropsWithChildren<unknown>> = (props) => (
  <h2 className="text-center text-xl leading-tight font-bold text-dark1">{props.children}</h2>
)
